/**
 * Wishlist グローバル管理
 * サイト全体で動作するお気に入り機能
 */

(function() {
  // Wishlist管理クラス
  class WishlistManager {
    constructor() {
      this.storageKey = 'wishlist';
      this.maxItems = 12;
      this.taxRate = 0.10; // 10%税率
      this.init();
    }

    init() {
      this.loadWishlist();
      // ページ読み込み時に初期化
      this.initButtons();
      // 動的に追加されるボタンにも対応
      this.observeButtons();
      this.updateBadge();
    }

    // localStorage からお気に入りを読み込み
    loadWishlist() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        this.items = stored ? JSON.parse(stored) : [];
      } catch (e) {
        console.error('[Wishlist] Failed to load:', e);
        this.items = [];
      }
    }

    // localStorage に保存
    saveWishlist() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.items));
      } catch (e) {
        console.error('[Wishlist] Failed to save:', e);
      }
    }

    // 商品をお気に入りに追加
    addItem(productId, variantId, handle) {
      // 重複チェック
      const exists = this.items.some(item => item.productId === productId);
      if (exists) return false;

      // 最大数チェック（古いものを削除）
      if (this.items.length >= this.maxItems) {
        this.items.shift(); // 最初の（最も古い）アイテムを削除
      }

      this.items.push({
        productId: productId,
        variantId: variantId,
        handle: handle,
        addedAt: Date.now()
      });

      this.saveWishlist();
      return true;
    }

    // 商品をお気に入りから削除
    removeItem(productId) {
      this.items = this.items.filter(item => item.productId !== productId);
      this.saveWishlist();
      return true;
    }

    // 商品がお気に入りに含まれているかチェック
    hasItem(productId) {
      return this.items.some(item => item.productId === productId);
    }

    // ボタンの初期化
    initButtons() {
      const buttons = document.querySelectorAll('[data-wishlist-btn]:not([data-wishlist-initialized])');
      
      buttons.forEach(button => {
        this.setupButton(button);
      });
    }

    // 個別ボタンのセットアップ
    setupButton(button) {
      // 初期化済みマーク
      button.setAttribute('data-wishlist-initialized', 'true');
      
      const productId = button.dataset.productId;
      const variantId = button.dataset.variantId;
      const handle = button.dataset.handle;
      
      // 初期状態を設定
      this.updateButtonState(button, this.hasItem(productId));
      
      // クリックイベント
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleWishlist(button, productId, variantId, handle);
      });
    }

    // 動的に追加されるボタンを監視
    observeButtons() {
      // MutationObserverで動的に追加される要素を監視
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              // 追加されたノード内のボタンを探す
              if (node.matches && node.matches('[data-wishlist-btn]:not([data-wishlist-initialized])')) {
                this.setupButton(node);
              }
              // 子要素も確認
              const buttons = node.querySelectorAll ? node.querySelectorAll('[data-wishlist-btn]:not([data-wishlist-initialized])') : [];
              buttons.forEach(button => this.setupButton(button));
            }
          });
        });
      });

      // body全体を監視
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // お気に入りの切り替え
    toggleWishlist(button, productId, variantId, handle) {
      const isInWishlist = this.hasItem(productId);
      
      if (isInWishlist) {
        this.removeItem(productId);
        this.updateButtonState(button, false);
        this.showToast('お気に入りから削除しました');
      } else {
        if (this.addItem(productId, variantId, handle)) {
          this.updateButtonState(button, true);
          this.showToast('お気に入りに追加しました');
        } else {
          this.showToast('すでにお気に入りに追加されています');
        }
      }
      
      this.updateBadge();
      this.updateAllButtons(productId);
    }

    // 同じ商品の全てのボタンを更新
    updateAllButtons(productId) {
      const buttons = document.querySelectorAll(`[data-wishlist-btn][data-product-id="${productId}"]`);
      const isActive = this.hasItem(productId);
      buttons.forEach(button => {
        this.updateButtonState(button, isActive);
      });
    }

    // ボタンの状態を更新
    updateButtonState(button, isActive) {
      const icon = button.querySelector('.mp-wishlist-icon');
      if (icon) {
        const onUrl = icon.dataset.iconOn;
        const offUrl = icon.dataset.iconOff;
        icon.src = isActive ? onUrl : offUrl;
      }
      button.setAttribute('aria-pressed', isActive);
      button.setAttribute('aria-label', isActive ? 'お気に入りから削除' : 'お気に入りに追加');
    }

    // トースト通知を表示
    showToast(message) {
      // 既存のトーストを削除
      const existingToast = document.querySelector('.wishlist-toast');
      if (existingToast) {
        existingToast.remove();
      }
      
      const toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      
      // アニメーション用
      setTimeout(() => toast.classList.add('show'), 10);
      
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    }

    // バッジの更新（ヘッダー等）
    updateBadge() {
      const badgeElements = document.querySelectorAll('[data-wishlist-count]');
      const count = this.items.length;
      
      badgeElements.forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
    }

    // Public API（他のスクリプトから呼び出し可能）
    getItems() {
      return this.items;
    }

    getCount() {
      return this.items.length;
    }

    refresh() {
      this.loadWishlist();
      this.initButtons();
      this.updateBadge();
    }
  }

  // グローバルインスタンス作成
  window.WishlistManager = WishlistManager;

  // DOMContentLoaded で初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.wishlistManager = new WishlistManager();
    });
  } else {
    window.wishlistManager = new WishlistManager();
  }

  // Shopifyのテーマイベントに対応（カートドロワー等の動的読み込み対応）
  document.addEventListener('shopify:section:load', () => {
    if (window.wishlistManager) {
      window.wishlistManager.initButtons();
    }
  });

  document.addEventListener('shopify:block:select', () => {
    if (window.wishlistManager) {
      window.wishlistManager.initButtons();
    }
  });
})();